import React from "react";

import ReactMarkdown from "react-markdown";
import { useSearchParams, useNavigate } from "react-router-dom";

import striptags from "striptags";
import rehypeRaw from "rehype-raw";

import styles from "./index.module.css";
import { slugify } from "../../utils";
import Calendar from "../Images/calendar";
import { getLabelColor } from "../../constants";

import "./index.css";
import { useTheme } from "../../themeContext";

const Post = ({ post }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const isIframeUrl = searchParams.get("iframe") === "true";
  const { isDark } = useTheme();

  const toAbsoluteDate = (isoString) => {
    const date = new Date(isoString);
    const pad = (n) => String(n).padStart(2, "0");

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = String(date.getFullYear());

    return `${day}/${month}/${year}`;
  };

  // title without html tags
  const { title = "", body = "", labels = [], created_at = "" } = post || {};
  const titleText = striptags(title);

  return (
    <article className={styles.post}>
      <div className={styles.postTagGroup}>
        {labels.map((label, index) => {
          const trimmedLabel = label.trim();

          const tagColor = getLabelColor(trimmedLabel, isDark);
          return (
            <div
              className={styles.postTagContainer}
              key={`${trimmedLabel}-${index}`}
            >
              <span
                className={styles.postTagLabelPrefix}
                style={{ background: tagColor }}
              />
              <span className={styles.postTagLabel}>{trimmedLabel}</span>
            </div>
          );
        })}
      </div>
      <div
        {...(!isIframeUrl && {
          "aria-label": `Navigate to ${titleText}`,
          role: "button",
          tabIndex: 0,
          style: { cursor: "pointer" },
          onClick: () => {
            const params = new URLSearchParams(
              Array.from(searchParams.entries())
            );
            navigate({
              pathname: `/${slugify(titleText)}`,
              search: params.toString(),
            });
          },
        })}
      >
        <h1 className={styles.postTitle}>{title}</h1>
      </div>
      <div className={styles.postBody}>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{body}</ReactMarkdown>
      </div>
      <div className={styles.postedAt}>
        <div className={styles.imageContainer}>
          <img
            src="../../testmu-logo.svg"
            alt="TestMu AI"
            width="16"
            height="18"
          />
          <p className={styles.postedByText}>TestMu AI (Formerly LambdaTest)</p>
        </div>
        <div className={styles.imageContainer}>
          <Calendar />
          <p className={styles.postedAtText}>{toAbsoluteDate(created_at)}</p>
        </div>
      </div>
    </article>
  );
};

export default Post;
